import {
  AfterViewInit,
  ContentChildren,
  Directive,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  NgZone,
  OnDestroy,
  Output,
  QueryList,
  Self,
} from '@angular/core';
import { CdkVirtualScrollViewport, VIRTUAL_SCROLL_STRATEGY } from '@angular/cdk/scrolling';
import { Subject } from 'rxjs';
import { defaultBeneficiaryCdkScrollConfig } from '../constants/beneficiary-scroll-config';
import { BeneficiaryScrollStrategyService } from '../services/beneficiary-scroll-strategy.service';
import { takeUntil } from 'rxjs/operators';

@Directive({
  selector: '[bnBeneficiaryScrollItem]',
})
export class BeneficiaryScrollItemDirective {}

export function factoryScroll() {
  return new BeneficiaryScrollStrategyService();
}

@Directive({
  selector: '[bbBeneficiaryScroll]',
  providers: [
    {
      provide: VIRTUAL_SCROLL_STRATEGY,
      useFactory: factoryScroll,
    },
  ],
})
export class BeneficiaryScrollDirective implements OnDestroy, AfterViewInit {
  private readonly destroy$ = new Subject();

  @ContentChildren(BeneficiaryScrollItemDirective, {
    descendants: true,
    read: ElementRef,
  })
  private listItems!: QueryList<ElementRef<HTMLElement>>;

  /**
   * Total items length of the list
   */
  @Input() bbBeneficiaryScrollTotalCount: number | undefined;

  /**
   * Trigger fetching more items
   */
  @Output('bbBeneficiaryScroll') loadMore = new EventEmitter<void>();

  constructor(
    @Self() private readonly viewport: CdkVirtualScrollViewport,
    @Inject(VIRTUAL_SCROLL_STRATEGY)
    private readonly scrollStrategy: BeneficiaryScrollStrategyService,
    private readonly ngZone: NgZone,
  ) {
    this.viewport.scrolledIndexChange.pipe(takeUntil(this.destroy$)).subscribe(() => {
      const dataLength = this.viewport.getDataLength();
      const { end } = this.viewport.getRenderedRange();

      if (dataLength && end === dataLength && dataLength !== this.bbBeneficiaryScrollTotalCount) {
        // CdkVirtualScrollViewport runs all events outside zone,
        // to detect changes we need to emit load more event inside zone.
        this.ngZone.run(() =>
          Promise.resolve().then(() => {
            this.loadMore.emit();
          }),
        );
      }
    });
  }

  ngAfterViewInit() {
    const { minBufferPx, maxBufferPx } = defaultBeneficiaryCdkScrollConfig;
    const listItemSize = this.listItems?.toArray()[0]?.nativeElement?.clientHeight;

    if (listItemSize) {
      this.scrollStrategy.updateItemAndBufferSize(listItemSize, minBufferPx, maxBufferPx);
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
  }
}
